var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.42276 12.6154C10.8646 12.6154 12.0381 11.4418 12.0381 9.99998V3.69229H13.1151C14.0486 3.69229 14.8074 4.45106 14.8074 5.3846V13.6923C14.8074 14.6258 14.0486 15.3846 13.1151 15.3846H5.42276C4.48922 15.3846 3.73046 14.6258 3.73046 13.6923V12.6154H9.42276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.26908 2.30766C1.26908 1.37289 2.02662 0.615356 2.96139 0.615356H9.42293C10.3577 0.615356 11.1152 1.37289 11.1152 2.30766V9.99997C11.1152 10.9347 10.3577 11.6923 9.42293 11.6923H2.96139C2.02662 11.6923 1.26908 10.9347 1.26908 9.99997V2.30766Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7692,
    height: 14.7692,
    fill: "white",
    transform: "matrix(-1 0 0 1 15.4229 0.615356)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.59ca42af5fa42fdedd5f08b13f2c7acd.svg";
export { ForwardRef as ReactComponent };